import { maxBreakpoints, minBreakpoints } from '@noths/polaris-client-ribbons-design-system';
import {
  mediaQuery,
  pxToRem,
  responsiveFontSize,
  shadowDown,
  stack,
  theme,
} from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing, text, colors, fonts } = theme;

export const FILTER_MENU_SMALL_TRANSITION_DURATION = 500;

/**
 * display: contents is needed for the sticky filter menu to work.
 */
export const smallScreenMenuWrapper = css`
  display: contents;
  @supports not (display: contents) {
    display: inline;
  }
`;

export const smallScreenMenu = css`
  top: 0;
  z-index: 1;
  background: #fff;
  margin: ${stack(spacing.xxl)};
  transition: transform ${FILTER_MENU_SMALL_TRANSITION_DURATION / 1000}s;
  position: static;
  transform: translateY('-100%');
  ${shadowDown};

  &[data-is-visible='true'] {
    transform: translateY(0);
  }

  &[data-is-sticky='true'] {
    position: sticky;
  }
`;

export const smallScreenCTAWrapper = css`
  margin: ${stack(spacing.md)};
  display: flex;
  justify-content: center;
`;

export const filterButton = css`
  width: 50%;
  background: 0;
  color: ${colors.blackPearl};
  border: ${pxToRem(1)} solid ${colors.blackPearl};
  border-radius: 0;
  border-width: ${pxToRem(1)} 0;

  :active {
    box-shadow: 0 ${pxToRem(4)} ${pxToRem(6)} 0 rgba(0, 0, 0, 0.1);
    background-color: ${colors.blueNavy};
  }

  &:first-child {
    border-right-width: ${pxToRem(1)};
  }

  &:last-child {
    border-left-width: ${pxToRem(1)};
    border-left-color: transparent;

    &.focus-visible {
      border-left-color: ${colors.blackPearl};
    }
  }

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      width: ${pxToRem(242)};
      border-width: ${pxToRem(1)};

      :first-child {
        border-radius: ${pxToRem(6)} 0 0 ${pxToRem(6)};
      }

      :last-child {
        border-radius: 0 ${pxToRem(6)} ${pxToRem(6)} 0;
      }
    `,
  )};
`;

export const largeScreenMenu = css`
  padding: ${stack(spacing.sm)};
  margin: ${stack(spacing.xxl)};
  ${shadowDown}
  background: white;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      margin: ${stack(spacing.xxxxl)};
    `,
  )};
`;

export const resetButton = css`
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  width: ${pxToRem(105)};
  ${responsiveFontSize(text.xs)};
`;

export const filterToolsWrapper = css`
  display: flex;
  align-items: center;
`;

export const filterLabel = css`
  margin: 0;
  width: ${pxToRem(110)};
  ${responsiveFontSize(text.sm)};
`;

export const productCount = css`
  ${responsiveFontSize(text.xxs)};
  margin: 0;

  ${mediaQuery(
    { max: maxBreakpoints.M },
    css`
      padding: ${stack(spacing.md)};
      text-align: center;
    `,
  )};
`;

export const filterBar = css`
  display: flex;
  align-items: center;
  grid-column: 2 / span 10;
`;

export const sortByWrapper = css`
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
`;
